// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const toggleReportsAccordion = () => ({
    type: actions.TOGGLE_OPEN_PIP_REPORTS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/pip/shared/action-creators/reports-accordion.js